// Namespaces are keyed {workspaceID}/{friendlyName}. The UI only ever shows the
// friendly name; the active workspace id is applied at the service boundary and
// stripped for display.

const NAME_RE = /^[A-Za-z0-9._-]+$/;

// isValidFriendlyName enforces the single-segment rule the backend requires:
// path.Match's '*' does not cross '/', so a name with '/' would escape the
// {workspaceID}/* grant. "." and ".." are rejected too — encodeURIComponent
// leaves them intact, so URL normalization could otherwise collapse a path
// segment and route to the wrong endpoint.
export function isValidFriendlyName(name: string): boolean {
  if (name === "." || name === "..") return false;
  return NAME_RE.test(name);
}

export function applyWorkspacePrefix(friendlyName: string, workspaceId: string): string {
  return `${workspaceId}/${friendlyName}`;
}

// stripWorkspacePrefix returns the friendly name for a full namespace under the
// given workspace, or null if it belongs to another workspace.
export function stripWorkspacePrefix(fullNs: string, workspaceId: string): string | null {
  const prefix = `${workspaceId}/`;
  if (!fullNs.startsWith(prefix)) return null;
  return fullNs.slice(prefix.length);
}

// encodeNsPath encodes each path segment for use in a URL while preserving the
// '/' separators (so {workspaceID}/{name} stays a real path).
export function encodeNsPath(fullNs: string): string {
  return fullNs.split("/").map(encodeURIComponent).join("/");
}
